import { api } from "./client.js";
import type { Role } from "@wwrp/shared";

export interface RoleMapping {
  id: number;
  discordRoleId: string;
  discordRoleName: string;
  role: Role;
  customColor: string | null;
}

export interface CreateRoleMappingBody {
  discordRoleId: string;
  discordRoleName: string;
  role: Role;
  customColor?: string | null;
}

export const roleMappingsApi = {
  list: () => api.get<RoleMapping[]>("/role-mappings"),

  colors: () => api.get<Partial<Record<Role, string>>>("/role-mappings/colors"),

  create: (body: CreateRoleMappingBody) => api.post<RoleMapping>("/role-mappings", body),

  patch: (id: number, body: { customColor: string | null }) =>
    api.patch<RoleMapping>(`/role-mappings/${id}`, body),

  delete: (id: number) => api.delete<{ ok: boolean }>(`/role-mappings/${id}`),
};
